import { applicationSettings } from '../application';
import { uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, UNITS } from '../../constants';
const { width, depth, height } = DIMENSIONS;

// TODO: Currently copied from IVAR. Adjust according to the needs in ELVARLI.
export default {
  postWidth: {
    [ITEMS.SECTION_POSTS]: 82,
    [ITEMS.SECTION_SIDE_UNITS]: 42,
  },
  distanceBetweenAttachments: 32,
  grid: uniformGrid(1),
  defaultFilter: 'sections',
  roomMin: {
    width: 1000,
    height: 1000,
  },
  roomMinCheckout: {
    width: 1000,
    height: 1000,
  },
  zoomableScene: false,
  sideWall: true,
  wall: {
    width: {
      min: 1000,
      max: 5700,
    },
    height: {
      min: 2220,
      max: 3500,
    },
    points:
      applicationSettings.uiPlatform === 'kiosk'
        ? [
            { x: 0, y: 0 },
            { x: 4600, y: 0 },
            { x: 4600, y: 2400 },
            { x: 0, y: 2400 },
          ]
        : [
            { x: 0, y: 0 },
            { x: 4000, y: 0 },
            { x: 4000, y: 2400 },
            { x: 0, y: 2400 },
          ],
    pointsMobilePortrait: [
      { x: 0, y: 0 },
      { x: 2400, y: 0 },
      { x: 2400, y: 2400 },
      { x: 0, y: 2400 },
    ],
    pointsMobileLandscape: [
      { x: 0, y: 0 },
      { x: 5700, y: 0 },
      { x: 5700, y: 2400 },
      { x: 0, y: 2400 },
    ],
    pointsTablet: [
      { x: 0, y: 0 },
      { x: 3900, y: 0 },
      { x: 3900, y: 2400 },
      { x: 0, y: 2400 },
    ],
  },
  canvasMargins: { top: 0, right: 0 },
  canvasMarginsKiosk: { top: 0, right: 0 },
  canvasMarginsMobile: {
    top: 0,
    right: 0,
  },
  canvasMarginsPortraitPercentual: {
    mobile: 0,
    tablet: 0,
  },
  sectionSnappingDistance: 50,
  showMultipleErrors: true,
  measurements: {
    productsRemap: [],
    displayMeasurement: [
      {
        affects: [ITEMS.SECTION_POSTS, ITEMS.SECTION_SIDE_UNITS],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: false,
          format: `${width} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.SHELF, ITEMS.DRAWER, ITEMS.ITEM],
        rules: {
          measure: true,
          display: false,
          measurementPrefix: true,
          format: `${width} ${MS}, ${depth} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: [],
  bulkArticles: {},
  colorCodes: {
    white: '#F8F8F7',
    bamboo: '#D6BDA1',
  },
};
